<template>
  <div class="login-page">
    <app-layout ovflowFlowMain="auto">
      <app-header slot="header"></app-header>
      <div class="login-main" slot="default">
        <div class="login-bg">
          <div class="login-header">少先队幸福成长课堂</div>
          <div class="login-body">
            <div class="login-title">登录</div>
            <a-form-model class="login-form" :model="loginForm" @submit.native.prevent="handleSubmit">
              <a-form-model-item>
                <a-input v-model="loginForm.account" placeholder="请输入用户名" size="large">
                </a-input>
              </a-form-model-item>
              <a-form-model-item>
                <a-input v-model="loginForm.password" type="password" placeholder="请输入密码" size="large">
                </a-input>
              </a-form-model-item>
              <div class="forget-password">
                <a-checkbox v-model="isSaveAccount" class="custom-checkbox">记住账号</a-checkbox>
                <a-checkbox v-model="isSavePassword" class="custom-checkbox">记住密码</a-checkbox>
                <a-button type="link" class="custom-button" @click="onForgetPasswordClick">忘记密码?</a-button>
              </div>
              <a-form-model-item>
                <a-button
                    html-type="submit"
                    :disabled="loginForm.account === '' || loginForm.password === ''"
                    class="submit-button"
                >
                  登录
                </a-button>
              </a-form-model-item>
            </a-form-model>
            <a-button type="link" class="custom-button pd0" @click="onConnectClick">联系客服</a-button>
          </div>
          <div class="login-footer">Copyright © 2021 版权所有ICP证：沪ICP备2021014876号</div>
        </div>
      </div>
      <a-modal
        :footer="null"
        :title="dialogTitle"
        v-model="connectVisible"
        :centered="true"
        dialogClass="custom__dialog custom__dialog--w500"
      >
        <h6 class="label text">{{dialogLabel}}</h6>
        <p class="text">联系方式：<span>{{connectMethod}}</span></p>
      </a-modal>
    </app-layout>
  </div>
</template>

<script>

import certificateManagement from '@/api/certificate-management'
import { others } from '@/api'
import util from './CommonUtil.js'
import md5 from 'js-md5';
var bConnect = 0

function getRandomNum (Min, Max) {
  var Range = Max - Min
  var Rand = Math.random()
  return (Min + Math.round(Rand * Range)).toString()
}

function onLoad () {
  
}

var digitArray = new Array('0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f')

function toHex (n) {
  var result = ''
  var start = true

  for (var i = 32; i > 0;) {
    i -= 4
    var digit = (n >> i) & 0xf

    if (!start || digit != 0) {
      start = false
      result += digitArray[digit]
    }
  }

  return (result == '' ? '0' : result)
}

export default {
  name: 'login',
  // 加密key
  randomNum: '',
  strData: '',
  keyName: '',
  keyPassword: '',
  keyID: '',
  keyIDInfo: '',
  keyNameInfo: '',
  keyPasswordInfo: '',
  keyStrDataInfo: '',
  msg: '',
  returnEncData: '',
  data () {
    return {
      loginForm: {
        account: '',
        password: ''
      },
      isSavePassword: false,
      isSaveAccount: false,
      randomNum: '',
      strData: '',
      connectVisible: false,
      dialogTitle: '',
      dialogLabel: '',
      connectMethod: ''
    }
  },
  mounted () {
    this.randomNum = getRandomNum(1, getRandomNum) + getRandomNum(1, 65535)// 赋值随机数，以实现一次一密
    this.strData = this.randomNum
    onLoad.call(this)
  },
  created () {
    let account = localStorage.getItem('account')
    if (account) {
      this.loginForm.account = account
      this.isSaveAccount = true
    }
    let password = localStorage.getItem('password')
    if (password) {
      this.loginForm.password = password
      this.isSavePassword = true
    }
    this.getConnectMethod()
    if (window.electronAPI) {
      window.electronAPI.onLoginSubmit((value) => {
        let params = value || {}
		let timestamp = new Date().getTime() / 1000;
		timestamp = Math.floor(timestamp)
		params.timestamp = timestamp
		params.sign = this.getSign(params)
		
        certificateManagement.loginV2(params).then(res => {
		  // 初始化websocket
          this.setUserInfo()
          this.$router.push('/index')
        }).catch(e => {
          if (e.response && e.response.data) {
            let { msg = '用户不存在或密码错误！' } = e.response.data
            return this.$message.error(msg)
          }
        })
      })
    }
  },
  methods: {
	getSign(params) {
		let data = util.sortObj(params)
		return md5(JSON.stringify(data)).toUpperCase();
	},
    getConnectMethod () {
      return others.connectMethod().then(res => {
        let { data, status, msg = '' } = res || {}
        if (status !== 'success') {
          this.$message.error(msg)
          return res
        }

        this.connectMethod = data
      })
    },
    onForgetPasswordClick () {
      this.connectVisible = true
      this.dialogTitle = '忘记密码'
      this.dialogLabel = '请联系客服修改密码'
    },
    onConnectClick () {
      this.connectVisible = true
      this.dialogTitle = '联系客服'
      this.dialogLabel = ''
    },
    handleSubmit () {
      let params = {
        email: this.loginForm.account,
        password: this.loginForm.password,
        // uuid: '737a691c-cd42-2020-0813-151318000000'
        uuid: localStorage.getItem('uuid')
      }
      if (window.electronAPI) {
        // 客户端打开
        window.electronAPI.handleLogin(params)
      }else{
        certificateManagement.login(params).then(res => {
          this.setUserInfo()
          this.$router.push('/index')
        }).catch(e => {
          if (e.response && e.response.data) {
            let { msg = '用户不存在或密码错误！' } = e.response.data
            return this.$message.error(msg)
          }
        })
      }
    },
    // 这里使用了异步的方式，因为WEBSOCKET是异步的
    // handleSubmitUSB: async function () {
    //   await this.loginChecking(this)// 这里等使用了await异步等的方式，因为WEBSOCKET是异步的
    //   let that = this;
    //   that.keyIDInfo = 'UKEY的ID是：' + that.keyID
    //   that.keyNameInfo = '从UKEY中获取到的用户名是：' + that.keyName
    //   console.log(that.keyNameInfo)
    //   that.keyPasswordInfo = '从UKEY中获取到的用户密码是：' + that.keyPassword
    //   if(that.keyPassword === undefined){
    //     that.keyPassword = '';
    //   }
    //   if(that.keyName === undefined){
    //     that.keyName = '';
    //   }
    //
    //   // 运行登录
    //   let params = {
    //     email: that.loginForm.account,
    //     password: that.loginForm.password,
    //     uuid: localStorage.getItem('uuid'),
    //     usb: that.keyPassword,
    //     usbUsername: that.keyName
    //   }
    //   certificateManagement.login(params).then(res => {
    //     that.setUserInfo()
    //     that.$router.push('/index')
    //   }).catch(e => {
    //     if (e.response && e.response.data) {
    //       let { msg = '用户不存在或密码错误！' } = e.response.data
    //       return this.$message.error(msg)
    //     }
    //   })
    // },
    error(str) {
      this.$info({
        title: str,
        okText: '知道了'
      })
    },
    // 储存表单信息
    setUserInfo () {
      // 判断用户是否勾选记住密码，如果勾选，向cookie中储存登录信息，
      // 如果没有勾选，储存的信息为空
      if (this.isSaveAccount) {
        localStorage.setItem('account', this.loginForm.account)
      }else{
        localStorage.setItem('account', '')
      }
      if (this.isSavePassword) {
        localStorage.setItem('password', this.loginForm.password)
      }else{
        localStorage.setItem('password', '')
      }
    },
    getCookie (key) {
      if (document.cookie.length > 0) {
        var start = document.cookie.indexOf(key + '=')
        if (start !== -1) {
          start = start + key.length + 1
          var end = document.cookie.indexOf(';', start)
          if (end === -1) end = document.cookie.length
          return unescape(document.cookie.substring(start, end))
        }
      }
      return ''
    },
    // 保存cookie
    setCookie (cName, value, expiredays) {
      var exdate = new Date()
      exdate.setDate(exdate.getDate() + expiredays)
      document.cookie = cName + '=' + decodeURIComponent(value) +
      ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
    }
  }
}
</script>

<style lang="less">
.login-page {
	.login-main{
		height: 100%;
		background-color: #2a2c39;
	}
  .login-body {
    .ant-input-lg {
      height: 50px;
    }

    .custom-checkbox {
      .ant-checkbox-inner {
        border-color: #CC2121;
      }

      .ant-checkbox-checked .ant-checkbox-inner {
        background-color: #CC2121;
      }

      .ant-checkbox::after {
        border-radius: 50%;
        border-color: #CC2121;
      }

      .ant-checkbox-inner {
        border-radius: 50%;
      }
    }
  }
}
.custom__dialog.custom__dialog--w500{
  width: 500px !important;
  .ant-modal-content{
    border-radius: 0;
  }
  .ant-modal-close{
    top: -36px;
    right: -36px;
  }
  .ant-modal-close-x{
    font-size: 36px;
    width: 36px;
    height: 36px;
    line-height: 36px;
    color: #fff;
  }
  .ant-modal-header{
    padding: 57px 0;
    text-align: center;
    border-bottom: none;
  }
  .ant-modal-title{
    font-size: 30px;
    color: #2E2E2E;
  }
  .ant-modal-body{
    padding: 20px 20px 120px 20px;
    .text{
      font-size: 24px;
      color: #323C47;
      line-height: 40px;
      text-align: center;
      span{
        color: #CE2323;
      }
    }
    p.text{
      margin-bottom: 0;
    }
  }
}
</style>

<style lang="less" scoped>
@import "../assets/style/index";

.login-bg {
  font-family: 'SourceHanSansCN-Medium';
  background-image: url('../assets/images/login/bg.jpg');
  min-height: 1006px;
  width: 1920px;
  background-size: 100% auto;
  background-repeat: no-repeat;
}

.login-header {
  color: #fff;
  font-size: 40px;
  padding: 180px 0 45px 0;
  text-align: center;
}

.login-body {
  width: 467px;
  height: 516px;
  margin: 0 auto;
  background-color: rgba(255, 255, 255, 1);
  padding: 60px 44px;

  .login-title {
    font-size: 24px;
    color: #333;
    font-weight: 600;
    text-align: center;
    line-height: 1;
    margin-bottom: 40px;
  }

  .forget-password {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .submit-button {
    height: 50px;
    border-radius: 8px;
    margin-top: 44px;
    width: 100%;
    background-image: linear-gradient(#CC2121, #E84545);
    border: 1px solid #CE2323; /*no*/
    box-shadow: 0px 20px 10px -16px #E84545;
    font-size: 22px;
    color: #fff;

    &:disabled {
      background-image: none;
      box-shadow: none;
      color: rgba(0, 0, 0, 0.25);
      border-color: #d9d9d9;
    }
  }

  .custom-button {
    color: #CC2121;
    font-size: 16px;
  }

  .pd0 {
    padding: 0;
  }
}

.login-footer {
  padding: 135px 0 0 0;
  text-align: center;
  font-size: 14px;
  color: #fff;
}
</style>
